import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useUnschedule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string }) => api.drafts.unschedule(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["drafts"] });
      qc.invalidateQueries({ queryKey: ["scheduled"] });
    },
  });
};
